/**
 * Utility functions for profile-related operations.
 */

/**
 * Generate thumbnail version of an image path.
 */
export function thumbnail(path: string): string {
  return path.replace(/(\.[^.]+)$/, `-thumbnail$1`);
}

/**
 * Generate trip URL based on share mode.
 */
export function getTripUrl(
  tripId: string,
  ownerName: string,
  shareMode: 'PUBLIC' | 'LINK' | 'PRIVATE',
  slug: string | undefined,
  linkSecret: string | undefined,
): string {
  if (shareMode === 'PRIVATE') {
    return `/p/trip/${tripId}`;
  }
  if (shareMode === 'PUBLIC' && slug) {
    return `/trip/${ownerName}/${slug}`;
  }
  // LINK mode
  return `/trip/${linkSecret}`;
}

/**
 * Generate trip header image URL.
 */
export function getTripHeaderUrl(tripId: string, fileName: string): string {
  const thumbnailPath = thumbnail(fileName);
  return `https://media.${process.env.REACT_APP_HOST}/${tripId}/${thumbnailPath}`;
}
